import React, { useEffect, useState } from 'react'

import {
  BottomSheet,
  Icon,
  Select,
  SH1,
  Stack,
  XStack,
} from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'

import { i18n } from '@zet/localization'
import { InputWithLabel } from '../inputWithLabel'

interface SelectDropDownProps {
  label?: string
  placeholder?: string
  onChange: (value: string) => void
  onBlur: () => void
  value?: string
  errorMessage?: string
  dropOptions?: any
  example: string
}

export const SelectDropDownBottomSheet: React.FC<SelectDropDownProps> = ({
  label = 'Select Dropdown',
  placeholder = 'Select',
  onChange,
  onBlur,
  value = '',
  errorMessage,
  dropOptions,
  example,
}) => {
  const [selectedValue, setSelectedValue] = useState<string>(value)
  const [isSheetVisible, setIsSheetVisible] = useState<boolean>(false)

  function selectOption(value: string) {
    setIsSheetVisible(false)
    onSelect('', value)
    setSelectedValue(value)
  }

  function closeBottomsheet() {
    setIsSheetVisible(false)
  }

  useEffect(() => {
    if (value) {
      setSelectedValue(value)
    }
  }, [value])

  const onSelect = (val: string, displayText: string) => {
    setSelectedValue(displayText)
    onChange(displayText)
    onBlur()
  }

  return (
    <Stack className="mb-3">
      <Pressable className="-mb-4" onPress={() => setIsSheetVisible(true)}>
        <InputWithLabel
          example={example}
          onChange={() => null}
          isEditable={false}
          placeholder={placeholder}
          onBlur={onBlur}
          iconRight={'ArrowDown'}
          iconLeft={'WorkOutlined'}
          value={value}
          label={label}
          errorMessage={errorMessage}
          pointerEvents="none"
        />
      </Pressable>

      {isSheetVisible && (
        <BottomSheet
          visible={isSheetVisible}
          onDismiss={closeBottomsheet}
          snapPoints={[400, 600]}
        >
          <>
            <XStack className="border-grays-30 items-center justify-between border-b px-3 py-2">
              <XStack className="items-center">
                <Icon type="WorkOutlined" size={24} />
                <SH1 className="ml-2">{i18n.t('employmentDetails.type')}</SH1>
              </XStack>
              <Pressable onPress={closeBottomsheet}>
                <Icon size={24} type="Close" />
              </Pressable>
            </XStack>
            <Stack className="px-3">
              <Select onChange={selectOption}>
                {dropOptions?.[0]?.fields?.map(({ key, displayValue }) => (
                  <Select.Option
                    key={key}
                    name={displayValue}
                    selectedValue={selectedValue}
                    optionContainerStyle="mt-3 w-full justify-center rounded-lg py-3"
                  >
                    <SH1>{displayValue}</SH1>
                  </Select.Option>
                ))}
              </Select>
            </Stack>
          </>
        </BottomSheet>
      )}
    </Stack>
  )
}
